"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  grid_breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
  },
  max_container_width: {
    sm: 540,
    md: 720,
    lg: 960,
    xl: 1140
  },
  column_gutter: {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24
  },
  outer_gutter: {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/glamorous-grid/lib/defaultTheme.js
// module id = ./node_modules/glamorous-grid/lib/defaultTheme.js
// module chunks = 2345137460201621000 7489246917808536000 9249036036638527000